__turbopack_context__.v({
  "bodyText": "rrwtPa_bodyText",
  "copy": "rrwtPa_copy",
  "copyWrapper": "rrwtPa_copyWrapper",
  "figure": "rrwtPa_figure",
  "hasBorder": "rrwtPa_hasBorder",
  "imageWrapper": "rrwtPa_imageWrapper",
  "promo": "rrwtPa_promo",
  "promoContainer": "rrwtPa_promoContainer",
  "reversed": "rrwtPa_reversed",
  "title": "rrwtPa_title",
});
